import { cn } from "@/lib/utils";

interface IconProps {
  className?: string;
}

/** Elegant hourglass — replaces Clock for duration */
export function IconHourglass({ className }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("h-4 w-4", className)}
      aria-hidden="true"
    >
      {/* Top & bottom bars */}
      <line x1="6" y1="2" x2="18" y2="2" />
      <line x1="6" y1="22" x2="18" y2="22" />
      {/* Hourglass body */}
      <path d="M7 2V7C7 9 9 12 12 12C9 12 7 15 7 17V22" />
      <path d="M17 2V7C17 9 15 12 12 12C15 12 17 15 17 17V22" />
      {/* Sand fill */}
      <path d="M9 17.5C9 16 10.5 14 12 14C13.5 14 15 16 15 17.5V22H9V17.5Z" fill="currentColor" opacity="0.15" stroke="none" />
    </svg>
  );
}
